import { AppThunk } from '../../store';
import { normalize, schema } from 'normalizr';
import cartoondrawApi from '../../api/cartoondrawApi';
import {
  setError,
  setLoading,
  setIds,
  setAssets
} from '../../store/cartoondraw/assetsSlice';

const CARTOONDRAW_URL = process.env.REACT_APP_CARTOONDRAW_URL;

const fullUrl = (url: any) => url ? `${CARTOONDRAW_URL}/${url}` : url;
const processStrategy = (value: any) => {
  return {
    ...value,
    media_url: fullUrl(value.media_url),
    image_url: fullUrl(value.image_url),
    second_image_url: fullUrl(value.second_image_url)
  };
}

const assetEntity = new schema.Entity(
  'assets',
  {},
  {
    processStrategy
  }
);

export const fetchAssets = (category_id: number): AppThunk => async dispatch => {
  dispatch(setLoading(true));

  cartoondrawApi.get(`/onesky/assets?category_id=${category_id}`)
    .then(response => {
      const normalized = normalize(response.data, [assetEntity]);
      dispatch(setIds(normalized.result))
      dispatch(setAssets(normalized.entities.assets))
      dispatch(setLoading(false));
    })
    .catch(response => dispatch(setError(response.data.errors)));
}

export const fetchPopular = (): AppThunk => async dispatch => {
  dispatch(setLoading(true));

  cartoondrawApi.get('/onesky/assets/populars')
    .then(response => {
      const normalized = normalize(response.data, [assetEntity]);
      dispatch(setIds(normalized.result))
      dispatch(setAssets(normalized.entities.assets))
      dispatch(setLoading(false));
    })
    .catch(response => dispatch(setError(response.data.errors)));
}
